import * as React from 'react'
import {useTranslation} from 'react-i18next'
import '../css/landing.css'
import '../css/monetization.css'
import {ACCENT_TEXT_FW500, tagger, setTitleFont} from '../util/util'
import {useEffect} from 'react'

const PrivacySdk = () => {
    const {t, i18n} = useTranslation('privacySdk')
    let activator = (e: any) => e.currentTarget.parentElement.lastChild.classList.toggle('active')

    useEffect(() => {
        setTitleFont(i18n.language)
    }, [])

    return (
        <div className="common-pages-container privacy">
            <p className="title muli">{tagger(t('Personaly SDK Privacy Policy'), ACCENT_TEXT_FW500)}</p>
            <div className="text">[Last Revised: June 6, 2018]</div>
            <div className="text">{tagger(t('OP Vision LTD dba'), ACCENT_TEXT_FW500)}</div>
            <div className="text">{tagger(t('Our technology enables us'), ACCENT_TEXT_FW500)}</div>
            <div className="text">{t('Personaly recognizes the importance')}</div>
            <div className="text">{tagger(t('This Policy describes Personaly'), ACCENT_TEXT_FW500)}</div>
            <div className="text">{t('We have included below information')}</div>
            <ul className="ul-decimal">
                <li>{t('Where you sign up for')}</li>
                <li>{t('If we have a legitimate interest')}</li>
                <li>{t('We will also process')}</li>
            </ul>
            <div className="accordion" style={{marginTop: '2rem'}}>
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Types of information we collect')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('The first type of information'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('The Non-Personal Information'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('The second type of information'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('Please note that we may collect'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('The third type of information'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Information we collect from business partners')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('If you are one of our')}</p>
                    <ul className="ul-disc">
                        <li>{tagger(t('Registration'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('Payment'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('Technical'), ACCENT_TEXT_FW500)}</li>
                        <li>{tagger(t('Newsletter Subscription'), ACCENT_TEXT_FW500)}</li>
                    </ul>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Information we collect from users')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('SDK, which is integrated')}</p>
                    <p className="text">{t('Personaly collects')}</p>
                    <p className="text">{tagger(t('Further, as detailed above'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Use of your information by personaly')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('Personaly uses the information')}</p>
                    <ul className="ul-disc">
                        <li>{t('Operate, manage, enhance and improve')}</li>
                        <li>{t('Respond to your inquiries')}</li>
                        <li>{t('Protect the rights')}</li>
                        <li>{t('Detect and report fraudulent')}</li>
                        <li>{t('Ensure eligibility to take')}</li>
                        <li>{t('Deliver targeted advertisements')}</li>
                    </ul>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('How we collect information')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('Depending on the nature of')}</p>
                    <p className="text">{t('For additional information regarding')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('How we collect information')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('Depending on the nature of')}</p>
                    <p className="text">{t('For additional information regarding')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Data collection by third parties')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('When you access or use the Service')}</p>
                    <p className="text">{t('The cookies and similar technologies')}</p>
                    <p className="text">{tagger(t('may also use cookies'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Third party content')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('The Service may link to third party content'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Sharing your information with other companies')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('Personaly will not share')}</p>
                    <p className="text">{tagger(t('We may disclose your Personal Information'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Your choices and controls')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('Your principal rights under')}</p>
                    <ul className="ul-lower-latin">
                        <li>{t('the right to access')}</li>
                        <li>{t('the right to rectification')}</li>
                        <li>{t('the right to erasure')}</li>
                        <li>{t('the right to restrict processing')}</li>
                        <li>{t('the right to object to processing')}</li>
                        <li>{t('the right to data portability')}</li>
                        <li>{t('the right to complain')}</li>
                        <li>{t('the right to withdraw consent')}</li>
                    </ul>
                    <p className="text">{tagger(t('We provide you with the ability'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('If you would like additional information'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Targeted advertising opt out option')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('Even after providing your consent')}</p>
                    <p className="text">{t('Options to opt out')}</p>
                    <ul className="ul-disc">
                        <li>{tagger(t('Learn how to opt-out from Android'), ACCENT_TEXT_FW500)} - <a href="https://support.google.com/ads/answer/2662922">https://support.google.com/ads/answer/2662922</a></li>
                        <li>{tagger(t('Learn how to opt-out from iOS'), ACCENT_TEXT_FW500)} - <a href="https://support.apple.com/en-il/HT205223">https://support.apple.com/en-il/HT205223</a></li>
                        <li>{t('You may control how your browser')}</li>
                        <li>{tagger(t('You may opt out of certain advertisers'), ACCENT_TEXT_FW500)}</li>
                        <li>{t('If you wish to opt out')}</li>
                        <li>{t('Our App Developers may also provide')}</li>
                    </ul>
                    <p className="text">{t('In the event, that you have')}</p>
                    <p className="text">{tagger(t('You may also Contact Us'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Childrens privacy')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('You represent and warrant that'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Data security and integrity')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('Your privacy is very important'), ACCENT_TEXT_FW500)} <a href="https://www.digitalocean.com/security/ ">https://www.digitalocean.com/security/ </a></p>
                    <p className="text">{tagger(t('Personaly also protects your privacy'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{t('Further, in the event of a data breach')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Data retention')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('We retain the Non-Personal Information')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Transfer of data')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('As a part of an international group')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Do not track disclosure')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('The Service does not respond')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Data protection officer')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('If you have any requests'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{t('Please be sure to include')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Modifications and updates')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('WE RESERVE THE RIGHT TO')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Market research')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('Personaly may share your personal information'), ACCENT_TEXT_FW500)}</p>
                    <ul className="ul-decimal">
                        <li>{t('Identifying client survey opportunities')}</li>
                        <li>{t('Disclosing such data elements')}</li>
                        <li>{t('Appending such data elements')}</li>
                        <li>{t('Other uses as set')}</li>
                    </ul>
                    <p className="text">{tagger(t('If you are eligible for'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Contact Us')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('If you have any questions')}</p>
                    <p className="text">
                        <span className="accent-text">O.P Vision LTD dba Persona.ly</span>
                        <br />Meir Weissgal Rd. 2, Rehovot
                        <br />{tagger(t('You can also contact us'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
        </div>
    )
}

export default PrivacySdk



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/privacySdk.tsx